import { isColumnVisibleByDefault } from '../../../utils/partialPermissionUtils';
import { getSessionTokenData } from '../../../utils/userUtils';
import plusIcon from '../../../assets/img/gantt/plusIcon.svg';

const checkedCol = (gantt, t) => {
  const name = 'checked';
  const isVisible = isColumnVisibleByDefault(name);

  return {
    name,
    align: 'center',
    label: 'Checked',
    hide: !isVisible,
    width: 30,
    groupable: false,
    orderable: false,
    filterable: false,
    data_type: 'string',
    ignore_as_column: true,
    template: (activity) => {
      const sessionTokenData = getSessionTokenData();
      const isOdd = gantt.oddColsConfig?.checked || false;

      if (activity.readonly) return '';

      let checkedAttribute = '';
      if (activity.mustApplyVisibleChecked) {
        checkedAttribute = activity.visibleChecked ? ' checked' : '';
      } else {
        checkedAttribute = activity.checked ? ' checked' : '';
      }

      const checkboxHtml = `
        <div class="${isOdd ? 'odd-col' : 'non-odd-col'} checked-for-gantt ${checkedAttribute ? 'checked-for-gantt-clicked' : ''}">
            <input class='gantt-checkbox-column' style="cursor: pointer; accent-color: #53C255;" onclick=window.to_use_react_gantt.runMultiSelectionMiddleware(${activity.id}) type='checkbox' name='test' id='test' value='1' ${checkedAttribute}/>
        </div>
      `;

      let addTaskLineHtml = '';
      if (['superadmin', 'admin', 'planner', 'projectleader'].includes(sessionTokenData?.role)) {
        addTaskLineHtml = `
          <div class="gantt_line_add_task_container">
            <div class="gantt_line_add_task" onclick="window.to_use_react_gantt.lineAddHandler(${activity.id})">
                <div class="gantt_line"></div>
                <div class="gantt_add_task">
                    <img src="${plusIcon}" width="8px" height="8px" alt="Plus Icon" />
                </div>
            </div>
          </div>
        `;
      }
      return checkboxHtml + addTaskLineHtml;
    },
  };
};

export default checkedCol; 